import it from "./it.json";
import en from "./en.json";

export const translations = {
  it,
  en,
};
